import React from 'react';
import {message, Modal} from 'antd';
import AccountRepo from "../../../../repository/account";
import {CL, MX, Default, Lana} from "./regions";

// Load body according to the region
const Child = ({region, ...props}) => {
  const regions = {
    "cl": <CL {...props} />,
    "mx": <MX {...props} />,
    "lana": <Lana {...props} />
  };

  const { account } = props;
  const regionKey = account.meta ? (account.meta.partner || region.toLowerCase()) : region.toLowerCase();

  return regions[regionKey] || <Default {...props} />
};

const AccountDetail = ({business, account, visible, close}) => {
  if (!account) {
    return <></>;
  }

  const save = data => {
    const keys = Object.keys(data).filter(k => data[k].trim() !== '');
    const metas = {};
    for (let k of keys) {
      metas[k] = data[k]
    }

    return new Promise((resolve, reject) => {
      AccountRepo.update(business, account, {meta: metas}).then(
        result => {
          message.success('Account data saved');
          resolve(result);
        },
        error => {
          console.error(error);
          message.error('Error saving account data');
          reject(error);
        }
      );
    });
  };

  return (
    <>
      <Modal
        visible={visible || false}
        title="Account details"
        onCancel={() => close(false)}
        footer={null}
      >
        <Child region={account.region_id} account={account} save={save} close={close} />
      </Modal>
    </>
  );
};

export default AccountDetail;
